module.exports = __webpack_public_path__ + "img/app1.9aad308b.png";